export const VERSION = 'version';

export const REDUCERS_ALLOWLIST = Object.freeze([
  'entities',
  'listeners', // NOTE: deprecated in version 2 of store
  'login',
  'smartConversion',
  'share',
  'storage',
  'stats',
  'usage',
  'skips',
  'replayQueue',
  'myStations',
  'ui',
]);

export const REDUCERS_TO_VALIDATE_AS_MAPS = Object.freeze(['entities', 'login']);

export const ENCRYPTED_REDUCERS_ALLOWLIST = ['login', 'skips', 'smartConversion'];

// when adding a reducer to this list, that reducer key will be exempt from
// becoming purged in local storage. this means that the data associated with
// the reducer key will stay in local storage even if a different listener logs in
export const REDUCERS_SESSION_INDEPENDENT_ALLOWLIST = Object.freeze([
  'education',
  'recentlyPlayedItems', // TODO: should remove after recently played api is implemented
  'source',
]);

// entire list of persisted reducers that are denoted in the config of createDomainModule.
// if a new domain has to be created and its reducer must be persisted, please add that
// reducer to this list
export const PERSISTED_DOMAIN_REDUCERS = Object.freeze([
  'audioAds',
  'collection',
  'recentlyPlayedItems',
  'debug',
  'education',
  'paypal',
  'partnerUpgrade',
  'specialOffers',
  'source',
  'userSettingsPersisted',
  'aps',
  'volume',
  'playlist',
  'stations',
  'rewards',
  'desktopApp',
  'device',
] as const);

export const TOTAL_ALLOWLISTED_REDUCERS = REDUCERS_ALLOWLIST.concat(PERSISTED_DOMAIN_REDUCERS);
